<template>
<b-container style="max-width: 1200px !important">
<b-row>
<b-col cols="12">
    <!--
    <b-row class="justify-content-around align-items-center">
        <b-col cols="5" sm="4" md="3">
            <b-img fluid-grow :src="require('@/assets/logo_Q_Plugin.svg')">
                <h2>Plug-In</h2>
            </b-img>
        </b-col>
        <b-col cols="5" sm="4" md="3">
            <b-img fluid :src="require('@/assets/external_logo/flowplayer.png')">
                <h2>Flowplayer</h2>
            </b-img>
        </b-col> 
    </b-row>
    -->
    <b-row class="mt-2">
    <vue-markdown style="overflow: auto" class="col-xl-7 col-12">
Example of index.html using Flowplayer and integrating **QUANTEEC** without DRM. DRM is possible only with the native version of Flowplayer.
```html
&lt;head>
    &lt;link href="flowplayer.css" rel="stylesheet" />

    &lt;script src="hls.min.js">&lt;/script>
    &lt;script src="flowplayer.min.js">&lt;/script>
    &lt;script src="https://files.quanteec.com/quanteec/latest/quanteec-hlsjs.min.js">&lt;/script> &lt;!-- 1-include QUANTEEC script-->
&lt;/head>
&lt;body>
    &lt;div style="max-width:726px;max-height:408px;">
        &lt;div id="videoplayer" >&lt;/div>
    &lt;/div>

    &lt;script>
        document.addEventListener("DOMContentLoaded", function () {
            var videoSource = "https://my.server.com/videoSource.mpd";

            // 2-Adjust QUANTEEC configuration
            var configQuanteec = {
                quanteecKey: "{{streamKey}}",
            };

            // 3-Link QUANTEEC to flowplayer *before* the creation of the flowplayer instance
            var quanteecPlayer = new Quanteec(configQuanteec, flowplayer);

            var flow = flowplayer('#videoplayer',
            { 
                key: "$512206430871778",
                clip: {
                    sources: [
                    {
                        type : "application/x-mpegurl",
                        src: videoSource,
                    }
                    ]
                },
                autoplay: true
            })

            // 4-Declare your flowplayer instance to QUANTEEC
            quanteecPlayer.setFlowplayer(flow);
        });
    &lt;/script>
&lt;/body>   
    </vue-markdown>
    <ConfigDoc class="col-xl-5 col-12">
    </ConfigDoc>
    </b-row>
</b-col>
</b-row>
</b-container>
</template>
<script>
import ConfigDoc from '@/components/documentation/plugins/ConfigDoc.vue';
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'Flowplayer',
  data: function() {
    return {
     
    }
  },
  props: [
      "streamKey"
  ],
  components: {
      VueMarkdown,
      ConfigDoc
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
     
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>